module.exports = __webpack_public_path__ + "media/images/icon-ambulance-b536c802ccc4b40e68e802cbbbd6128f.png";